import React, { FC, useCallback } from 'react';

import { AdType } from './enums';

import { FullSizeAd, MobileSapHeaderAd } from './styles';

type Props = {
    divId: string;
    adType: AdType;
    forceReload?: boolean;
};

const AdTag: FC<Props> = ({ divId, adType, forceReload = false }) => {
    const displayAdTag = (node: HTMLDivElement | null, divId: string) => {
        if (node !== null) {
            window.googletag = window.googletag || { cmd: [] };

            window.googletag.cmd.push(() => {
                window.googletag.display(divId);
                forceReload && window.googletag.pubads().refresh();
            });
        }
    };

    const displayAdCallback = useCallback((node: HTMLDivElement) => displayAdTag(node, divId), []);

    if (divId) {
        switch (adType) {
            case AdType.FULL_SIZE:
                return <FullSizeAd ref={displayAdCallback} id={divId} />;
            case AdType.SAP_DESKTOP:
                return <div ref={displayAdCallback} id={divId} />;
            case AdType.SAP_MOBILE:
                return <MobileSapHeaderAd ref={displayAdCallback} id={divId} />;
        }
    }

    return <></>;
};

export default AdTag;
